module.exports = __webpack_public_path__ + "static/media/b2_p13_clickable_ph.400086c7.png";